import { Brand, I18NText, Position, State } from 'src/types'
import { getYellStoryBaseCells, getYellStoryColorCells } from 'src/features/brands/yellStory/simulatedSpecification'
import { genRagDeLionBaseCells, getRagDeLionGloveColorCells } from 'src/features/brands/ragdelion/simulatedSpecification'
import { getDxMBaseCells, getDxMGloveColorCells } from 'src/features/brands/dxm/simulationSpecification'
import { getGorillaBaseCells, getGorillaGloveColorCells } from 'src/features/brands/gorilla/simulationSpecification'
import { getAtomsBaseCells, getAtomsGloveColorCells } from 'src/features/brands/atoms/simulationSpecification'

export const genBaseCells = (state: State, brand: Brand, position: Position, t: I18NText) => {
  switch (brand) {
    case 'atoms':
      return getAtomsBaseCells(state, position, t)
    case 'yellStory':
      return getYellStoryBaseCells(state)
    case 'ragdelion':
      return genRagDeLionBaseCells(state, position)
    case 'dxm':
      return getDxMBaseCells(state, position, t)
    case 'gorilla':
      return getGorillaBaseCells(state, position)
    // case 'treasure': {
    //   const isTreFirstBackStyle = [state.backStyle?.value].includes('firstBackStyle')
    //   const isRegularCMitt = isCatcher && state.backStyle?.value === 'regularBackStyle'
    //   return [
    //     genGloveBaseCell('種別', state.kinds),
    //     genGloveBaseCell('基本モデル', baseModelStateObj),
    //     genGloveBaseCell('利き腕', state.dominantArm),
    //     genGloveBaseCell('バックスタイル', state.backStyle),
    //     !isRegularCMitt && !isTreFirstBackStyle && genGloveBaseCell('ベルトタイプ', state.beltType),
    //     (isRegularCMitt || isTreFirstBackStyle) && genGloveBaseCell('ラベル取付位置', state.labelPosition),
    //     isGlove && genGloveBaseCell('サイズ調整', state.size),
    //     isGlove && genGloveBaseCell('背面ひも通し', state.backLace),
    //     isGlove && genGloveBaseCell('トジ部', state.materialPack),
    //     isGlove && genGloveBaseCell('トジ部のひも通し', state.bankLaceDirection),
    //     isGlove && genGloveBaseCell('ウェブパーツ', state.webParts),
    //     genGloveBaseCell('指カバー/指当て', state.fingerGuardType)
    //   ].filter(Boolean)
    // }
  }
}

export const genGloveColorCells = (state: State, brand: Brand, position: Position, t: I18NText) => {
  switch (brand) {
    case 'atoms':
      return getAtomsGloveColorCells(state, position, t)
    case 'yellStory':
      return getYellStoryColorCells(state, t)
    case 'ragdelion':
      return getRagDeLionGloveColorCells(state, position, t)
    case 'dxm':
      return getDxMGloveColorCells(state, position, t)
    case 'gorilla':
      return getGorillaGloveColorCells(state, t)
    // case 'treasure': {
    //   const isTreasureEmblem = state?.beltType?.value === 'treasureOriginal'
    //   return [
    //     ...commonGloveColorCells,
    //     ...variablePartsCells,
    //     isTreasureEmblem && genGloveColorCell('Treasureエンブレム', state.treasureOriginalParts, 'treasureOriginalParts'),
    //     genGloveColorCell('Treasureラベル(メイン)', state.treasureLabelMain, 'treasureLabelMain'),
    //     genGloveColorCell('Treasureラベル(影)', state.treasureLabelShadow, 'treasureLabelShadow'),
    //     genGloveColorCell('Treasureラベル(台)', state.treasureLabelStand, 'treasureLabelStand')
    //   ].filter(Boolean)
    // }
  }
}
